var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',{attrs:{"form":_vm.retrieveForm},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'telphone',
        {
          rules: [
            { required: true, message: '请输入手机号码' },
            { pattern: /^1[34578]\d{9}$/, message: '手机号码格式不正确' }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'telphone',\n        {\n          rules: [\n            { required: true, message: '请输入手机号码' },\n            { pattern: /^1[34578]\\d{9}$/, message: '手机号码格式不正确' }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"placeholder":"请输入手机号"}})],1),_c('a-form-item',[_c('a-button',{attrs:{"type":"primary","html-type":"submit","loading":_vm.loading}},[_vm._v("下一步")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }